import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class AppHeader extends Vue {
  public get title(): string {
    return this.$route.meta.title;
  }
}
